import React from 'react';
import { Box, Image, Spinner, Center } from '@chakra-ui/react';

const BlurredImage = ({ imageUrl, blurLevel, loading }) => {
  if (loading || !imageUrl) {
    return (
      <Center h="300px" w="100%">
        <Spinner size="xl" color="brand.500" thickness="4px" />
      </Center>
    );
  }

  return (
    <Box 
      position="relative" 
      width="100%" 
      maxW="500px" 
      mx="auto"
      borderRadius="lg"
      overflow="hidden"
      boxShadow="xl"
      bg="white"
      p={2}
    >
      <Image
        src={imageUrl}
        alt="Guess this image"
        width="100%"
        height="auto"
        objectFit="contain"
        style={{ 
          filter: `blur(${blurLevel}px)`,
          transition: 'filter 0.5s ease-out'
        }}
      />
    </Box>
  );
};

export default BlurredImage;